import { Observable } from 'rxjs';

export interface AccountForm {
  aa_uacs_code: string,
  aa_acct_name: string,
  aa_amount: string,
  aa_year: string,
  aa_fnd_sysref_code: string,
  member_id: string,
  campus_branch_code: string,
  aa_planned_amount: string
  within_nep: string,
  not_within_nep: string,
  collectibles: string
  // aa_savings: string;      
  // aa_continuing: string;   
}

export interface UpdateAccountForm {
  aa_id: string,
  aa_amount: string,
  aa_planned_amount: string
  within_nep: string,
  collectibles: string
  // aa_savings: string;      
  // aa_continuing: string;
}

export interface DeleteAccountForm {
  aa_id: string
}

export interface BudgetFundInputForm {
  aa_year: string,
  aa_fnd_sysref_code: string,
  campus_branch_code: string,
  allotment_class: string
}

export interface adjustmentForm {
  dt: any,
  from: any,
  to: any,
  s_campus: any,
  d_campus: any
}

export interface updateAdjustmentForm {
  code: any,
  campus: any,
  status: any
}

export interface deleteAdjustmentForm {
  code: any,
  campus: any,
}

export interface fetchAdjustmentForm {
  campus: any,
  year: any
}

export interface ApiResponse {
  code: number,
  message: any
}

export abstract class AccountData {
  abstract save(param: AccountForm): Observable<ApiResponse>;
  // abstract get(param: BudgetFundInputForm): Observable<ApiResponse>;
  abstract getSummary(param: BudgetFundInputForm): Observable<ApiResponse>;
  abstract update(param: UpdateAccountForm): Observable<ApiResponse>;
  abstract delete(param: DeleteAccountForm): Observable<ApiResponse>;
  abstract adjustment(param: adjustmentForm): Observable<ApiResponse>;
}
